<template>

  <!-- Event Theme Card -->
  <div
    class="event-theme-card">

    <div
      class="event-theme-card__wrapper row q-col-gutter-xs">

      <div
        class="col-12 col-md-2">

        <div
          class="event-theme-card__aside">

          <div
            class="q-mr-md-xs">

            <div
              v-if="value.startTime && value.endTime">
              {{ value.startTime + ' - ' + value.endTime }}
            </div>

            <div
              v-else-if="value.startTime">
              {{ value.startTime }}
            </div>

            <div
              v-else>
              Без времени
            </div>

            <div
              v-if="hall.ru"
              class="text-body1 text-bold q-mt-xs text-center">
              {{ hall.ru }}
            </div>

          </div>

        </div>

      </div>

      <div
        class="col-12 col-md-10">

        <div
          class="event-theme-card__tile">

          <div
            class="event-theme-card__tile-title">
            {{ value.title.ru }}
          </div>

          <div
            v-if="value.comment.ru"
            class="text-body1 q-mt-sm">
            {{ value.comment.ru }}
          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'event-theme-card',
    props: {
      value: {
        type: Object,
        required: true,
      },
      hall: {
        type: [Object, String],
        default: null,
      },
    },
  };

</script>

<style lang="scss">

  .event-theme-card {

    &__wrapper > div {
      height: 100%;
    }

    &__tile {
      height: 100%;
      min-width: 0;
      display: flex;
      text-align: left;
      padding: 1.4rem 2rem;
      flex-direction: column;
      justify-content: center;
      background-color: transparentize(#999, .88);
    }

    &__aside {
      height: 100%;
      display: flex;
      font-weight: 200;
      font-size: 1.3rem;
      padding: 1.4rem 0;
      letter-spacing: 1px;
      align-items: center;
      justify-content: center;
    }

    &__tile-title {
      font-size: 1.4rem;
    }
  }

</style>
